import type { OfficeToHomeBuffer } from "./office_to_home_warning";

export interface ConsultSlotEntry {
  time: string;
  durationMinutes: number;
  key: string;
  officeToHomeBuffer: OfficeToHomeBuffer | null;
  selectable: boolean;
  devaLocation: string;
  devaLocationLabel: string;
  offeredVisitTypes: string[];
  dateLabel: string;
  timeLabel: string;
  scheduleLabel: string;
  offeredPatients: Array<{ name: string; schedulingPageViewed: boolean }>;
  bookedPatientName?: string | null;
  bookedPatientPath?: string | null;
  bookedConsultTypeLabel?: string | null;
  bookedConsultPath?: string | null;
}

export interface SelectedConsultSlot {
  key: string;
  officeToHomeBuffer: OfficeToHomeBuffer | null;
  date: string;
  time: string;
  custom: boolean;
  devaLocation: string;
  devaLocationLabel: string;
  offeredVisitTypes: string[];
  dateLabel: string;
  timeLabel: string;
  scheduleLabel: string;
}

export interface ConsultAvailabilityDate {
  date: string;
  label: string;
  description: string;
  openSlotCountLabel: string;
  bookedSlotCountLabel: string;
  hasBookedSlots: boolean;
  entries: ConsultSlotEntry[];
}

export type ConsultAvailabilityView = "classic" | "calendar";

export interface ConsultAvailability {
  view: ConsultAvailabilityView;
  today: string;
  requestedStartDate: string;
  startDate: string;
  endDate: string;
  previousStartDate?: string | null;
  nextStartDate: string;
  rangeLabel: string;
  emptyMessage: string;
  slotTypeFilter: string;
  selectedSlotKeys: string[];
  selectedSlots: SelectedConsultSlot[];
  defaultSelectedSlotKeysByFilter: Record<string, string[]>;
  defaultSlotSelectionActive: boolean;
  dates: ConsultAvailabilityDate[];
}

export function selectedSlotFromEntry(date: ConsultAvailabilityDate, entry: ConsultSlotEntry): SelectedConsultSlot {
  return {
    key: entry.key,
    officeToHomeBuffer: entry.officeToHomeBuffer,
    date: date.date,
    time: entry.time,
    custom: false,
    devaLocation: entry.devaLocation,
    devaLocationLabel: entry.devaLocationLabel,
    offeredVisitTypes: entry.offeredVisitTypes,
    dateLabel: entry.dateLabel || date.label,
    timeLabel: entry.timeLabel,
    scheduleLabel: entry.scheduleLabel,
  };
}
